module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "المقدمة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المقدِّمة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أظنُّ أنَّ هناك سبيلًا لتقديم قصة كتبتُها بنفسي ووجداني، وشارك قلبي كثيرًا في تهذيب سطورها، إلا إنَّني قد أهمس لك بمغزى الرواية رغبةً منِّي في مساعدتك على الغوص في أعماق سطورها عوضًا عن أن تطفو على ضفاف كلماتها فقط.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنًا.. كلُّ ما في الأمر أنَّني أريدك أن تسلِّط الضوء على بعض الأماكن المظلمة مِن حياتك، علَّك تجد فيها ما يجعلك تشعُّ وتزداد إشراقًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0